import { createContext, useContext, useEffect, useId } from "react";
import { useLocation } from "react-router-dom";

export interface TeamDisabled {
  teamDisabled: boolean;
  setTeamDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  consumer: string | null;
}

export const TeamDisabledContext = createContext<TeamDisabled | null>(null);

export const useTeamDisabledContext = (): TeamDisabled => {
  const teamDisabled = useContext(TeamDisabledContext);
  if (!teamDisabled) {
    throw new Error("Called useTeamDisabled outside of <BasePage>");
  }
  return teamDisabled;
};

export const useDisableTeam = (disabled: boolean = true) => {
  const context = useTeamDisabledContext();
  const location = useLocation();
  const id = useId();

  useEffect(() => {
    if (context.consumer) return;

    context.consumer = id;
    context.setTeamDisabled(disabled);

    return () => {
      if (context.consumer === id) {
        context.consumer = null;
      }
    };
  }, [context, location.pathname, disabled, id]);
};
